/**
 * Thin, provider-agnostic event layer for the public acquisition funnel.
 *
 * The portal currently ships no analytics provider, which means the landing
 * page, the calculator and the signup funnel produce no measurable signal. This
 * module puts the tracking calls in the right places today and stays a no-op
 * until a provider is present — so switching one on is a script tag, not a
 * refactor.
 *
 * To enable GA4: add the gtag snippet to `index.html`. Nothing here changes.
 */

/** Events fired from the public funnel. Keep this list closed and named by intent. */
export const ANALYTICS_EVENTS = {
  LANDING_VIEWED: "landing_viewed",
  LANDING_CTA_CLICKED: "landing_cta_clicked",
  CALCULATOR_VIEWED: "calculator_viewed",
  CALCULATOR_ADJUSTED: "calculator_adjusted",
  CALCULATOR_SHARED: "calculator_shared",
  CALCULATOR_CTA_CLICKED: "calculator_cta_clicked",
  SIGNUP_STARTED: "signup_started",
  SIGNUP_STEP_COMPLETED: "signup_step_completed",
  SIGNUP_SUBMITTED: "signup_submitted",
};

/**
 * Report an event to whichever provider is installed.
 * Silently does nothing when none is.
 *
 * @param {string} event - one of ANALYTICS_EVENTS
 * @param {object} [params] - flat key/value payload
 */
export function trackEvent(event, params = {}) {
  if (!event) return;

  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, params);
      return;
    }

    if (
      typeof window !== "undefined" &&
      Array.isArray(window.dataLayer)
    ) {
      window.dataLayer.push({ event, ...params });
    }
  } catch (error) {
    // Analytics must never break a page render.
    console.warn(`Analytics event "${event}" failed: ${error.message}`);
  }
}
